import { render, staticRenderFns } from "./view-qualification-officers.vue?vue&type=template&id=81908928&scoped=true"
import script from "./view-qualification-officers.vue?vue&type=script&lang=js"
export * from "./view-qualification-officers.vue?vue&type=script&lang=js"
import style1 from "./view-qualification-officers.vue?vue&type=style&index=1&id=81908928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81908928",
  null
  
)

export default component.exports